import ReactPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';
import URLSearchParams from 'url-search-params';
import { Cookies } from 'react-cookie';

import string from '../localization';
import config from '../../constants/config';
import countryCode from './iso_639_2_to_iso_639_1.js';

const cookies = new Cookies();

export function uuid() {
  let uuid = '';
  let i;
  let random;
  for (i = 0; i < 32; i++) {
    random = (Math.random() * 16) | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += '-';
    }
    uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
  }
  return uuid;
}

export function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function isEmpty(variable) {
  if (variable === null) {
    return true;
  }
  if (typeof variable === 'string' || Array.isArray(variable)) {
    return variable.length === 0;
  } else if (typeof variable === 'object') {
    return Object.keys(variable).length === 0;
  }
}

export function capitalizeEachWord(string) {
  if (!string) {
    return '';
  }
  return string.replace(/(^|\s)\S/g, (l) => {
    return l.toUpperCase();
  });
}

export function getUrlParams(url) {
  if (!url || typeof url === 'undefined') {
    return {};
  }
  const str = url.split('?')[1].split('&');
  const obj = {};
  str.forEach((s) => {
    const tmp = s.split('=');
    obj[tmp[0]] = tmp[1];
  });
  return obj;
}

export function getReduxStateFromStorage() {
  try {
    const serailizedState = localStorage.getItem('__REDUX_STATE__');
    if (serailizedState === null) {
      return undefined;
    }
    return JSON.parse(serailizedState);
  } catch (e) {
    return undefined;
  }
}

export function saveReduxStateToStorage(state) {
  try {
    const serailizedState = JSON.stringify(state);
    localStorage.setItem('__REDUX_STATE__', serailizedState);
  } catch (e) {
    // console.log('CANNOT SAVE REDUX TO LOCAL STORAGE', e);
  }
}

export function deleteReduxStateFromStorage() {
  localStorage.setItem('__REDUX_STATE__', JSON.stringify({}));
}

/**
 * Check if 2 simple array have same values, not for array of objects
 * @param array array1 [1, 2, 3, 4 ...]
 * @param array array2 [1, 2, 3, 4 ...]
 * @return bool
 */
export function simpleArrayCompare(array1, array2) {
  return array1.sort().join(',') === array2.sort().join(',');
}

export function filterProfiles(currentProfiles, nextProfiles) {
  const currentProfileIds = currentProfiles.map((p) => {
    if (p.hasOwnProperty('id')) {
      return p.id;
    } else if (p.hasOwnProperty('user_id')) {
      return p.user_id;
    }
    return null;
  });
  let newProfiles = [];
  if (currentProfileIds.length > 0) {
    nextProfiles.forEach((u) => {
      if (u.hasOwnProperty('id')) {
        if (currentProfileIds.indexOf(u.id) === -1) {
          newProfiles.push(u);
        }
      } else if (u.hasOwnProperty('user_id')) {
        if (currentProfileIds.indexOf(u.user_id) === -1) {
          newProfiles.push(u);
        }
      }
    });
  } else {
    newProfiles = [...nextProfiles];
  }

  return newProfiles;
}

/**
 * Gender prefered sex helper
 * return gender names based on bitmask & bit
 * https://docs.google.com/document/d/1Z1wBM-yFLC9c9WGCLtmNn0Vn7ig009zVdOSyLSKsbMI/edit#
 */
export function getSeekingGender(bits) {
  bits = bits.toString(2); // convert to binary
  let genderArray = [];
  let firstGender = 1;
  let secondGender = 2;
  let other = 4;
  let genderOne = string.genderOne;
  let genderTwo = string.genderTwo;
  let otherGenderName = string[`${config.GENDER_OTHER_VARIABLE_NAME}`];
  let maskFirst = firstGender;
  let maskSecond = secondGender;
  let maskOther = other;

  if (maskFirst & bits) {
    genderArray.push(genderOne);
  }
  if (maskSecond & bits) {
    genderArray.push(genderTwo);
  }
  if (maskOther & bits) {
    genderArray.push(otherGenderName);
  }
  return genderArray.length > 0 && genderArray.join(' & ');
}

/**
 * This doesn't use bitmask so we have to handle it in switch like
 * @param int
 */
export function getGender(int) {
  let genderOne = string.genderOne;
  let genderTwo = string.genderTwo;
  let otherGenderName = string[`${config.GENDER_OTHER_VARIABLE_NAME}`];
  switch (int) {
    case '1':
      return genderOne;
    case '2':
      return genderTwo;
    case '3':
      return otherGenderName;
    default:
      return otherGenderName;
  }
}

export function getGenderInner(int) {
  let genderOne = string.genderOne;
  let genderTwo = string.genderTwo;
  let otherGenderName = string[`${config.GENDER_OTHER_VARIABLE_NAME}`];
  switch (int) {
    case 1:
      return genderOne;
    case 2:
      return genderTwo;
    case 3:
      return otherGenderName;
    default:
      return otherGenderName;
  }
}

/**
 * Get Gender and Seeking from url
 * @param {string} url `gender=Cuckold&seeking=Bull`
 * @returns {object} {gender: 'Cuckold', seeking: 'Bull'}
 */
export function parseGenderAndSeekingFromUrl(url) {
  const query = new URLSearchParams(url);
  const gender = query.get('gender');
  const seeking = query.get('seeking');
  return { gender, seeking };
}

/**
 * Get seeking bitmask value for gender, comparing it to config object
 * We convert config object id's to bitmask values and return gender summed value
 * @param {string} genders Bull,Hotwife/Couple,Cuckold
 * @param {object} gendersConfig {1: 'Cuckold', 2: 'Bull', 3: 'Hotwife/Couple'}
 */
export function getSeekingGenderBitmaskValue(seeking, gendersConfig) {
  const genderArray = seeking.split(',');
  return genderArray
    .map((e) => {
      let number;
      for (var key in gendersConfig) {
        if (
          gendersConfig.hasOwnProperty(key) &&
          gendersConfig[key].toLowerCase() === e.toLowerCase()
        ) {
          number = number === undefined ? key : undefined;
        }
      }
      return +number === 3 ? +number + 1 : +number;
    })
    .reduce((sum, num) => {
      return sum + num;
    });
}

/**
 * Return gender Id based on mapped GenderConfig data and Gender name, ignorin case
 * @param {object} genders {gender: 'Cuckold', seeking: 'Bull,Hotwife/Couple'}
 * @param {object} gendersConfig {1: 'Cuckold', 2: 'Bull', 3: 'Hotwife/Couple'}
 * @return {object} result {gender: 1, seeking: 5}
 */
export function getGenderIdBasedOnGendersConfig(genders, gendersConfig) {
  let genderIndex;
  if (gendersConfig && genders && genders.gender) {
    for (var key in gendersConfig) {
      if (
        gendersConfig.hasOwnProperty(key) &&
        gendersConfig[key].toLowerCase() === genders.gender.toLowerCase()
      ) {
        genderIndex = genderIndex === undefined ? key : undefined;
      }
    }
  }
  const seekingIndex = getSeekingGenderBitmaskValue(
    genders.seeking,
    gendersConfig
  );
  return {
    gender: (genderIndex && parseInt(genderIndex, 10)) || undefined,
    seeking: seekingIndex || undefined,
  };
}

/**
 * Get array index of config.GENDER_SEEKING_SIGNUP_LOGIN based on gender & seeking
 * @param {int} gender int
 * @param {int} seeking bitmask
 * @returns {int} index
 */
export function getConfigIndexValueForGenderAndSeekingBasedOnGenders(
  gender,
  seeking,
  genderAndSeekingCombo = null
) {
  const genderSeekingValue = String(gender) + '_' + String(seeking);
  let genderSeekingSignupLoginArray = [];
  if (config.GENDER_SEEKING_SIGNUP_LOGIN) {
    genderSeekingSignupLoginArray =
      config.GENDER_SEEKING_SIGNUP_LOGIN.visibleOptions.concat(
        config.GENDER_SEEKING_SIGNUP_LOGIN.moreOptions
      );
  } else {
    if (genderAndSeekingCombo) {
      genderSeekingSignupLoginArray = [...genderAndSeekingCombo, '2_2', '1_1'];
    } else {
      genderSeekingSignupLoginArray = ['1_2', '2_1', '2_2', '1_1']; // default options based on Todds recomendation for 2 gender sites, components/Auth/EmailRegister/Steps/StepOne/StepOne.js:28
    }
  }

  return genderSeekingSignupLoginArray.indexOf(genderSeekingValue);
}

export function getNewSeekingValue(value) {
  switch (value) {
    case 1:
      return '1';
    case 2:
      return '2';
    case 3:
      return '1,2';
    case 4:
      return '3';
    case 5:
      return '1,3';
    case 6:
      return '2,3';
    case 7:
      return '1,2,3';
    default:
      return 1;
  }
}

export function getOldSeekingValue(value) {
  const str = value.toString();

  switch (str) {
    case '1':
      return 1;
    case '2':
      return 2;
    case '1,2':
      return 3;
    case '3':
      return 4;
    case '1,3':
      return 5;
    case '2,3':
      return 6;
    case '1,2,3':
      return 7;
    default:
      return 1;
  }
}

export function getScrollState() {
  return {
    height: document.body.scrollHeight, // full height of page to scroll
    top: window.scrollY, // px scrolled from top
    bottom: document.body.scrollHeight - (window.scrollY + window.innerHeight), // px remains to reach bottom
  };
}

export function isAlternateAuthAvailable(getConfig) {
  return (
    config.TYPE !== 'adult' &&
    getConfig.response &&
    getConfig.response.ios_auth &&
    getConfig.response.ios_auth.query_params &&
    getConfig.response.ios_auth.query_params.response_type &&
    getConfig.response.ios_auth.query_params.response_mode &&
    getConfig.response.ios_auth.query_params.client_id &&
    getConfig.response.ios_auth.query_params.redirect_uri &&
    getConfig.response.ios_auth.query_params.scope
  );
}

export function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
}

export function deviceId() {
  let currentId = localStorage.getItem('__DEVICE_ID__');
  if (currentId !== null) {
    return currentId;
  } else {
    localStorage.setItem('__DEVICE_ID__', uuid());
    currentId = localStorage.getItem('__DEVICE_ID__');
    return currentId;
  }
}

export function trackBingCreateAccount() {
  // window.uetq && window.uetq.push('event', 'page_view', { page_path: '/signup' });
  window.uetq &&
    window.uetq.push({
      ec: 'registration',
      ea: 'free',
      el: 'Free Registration',
      ev: '0',
    });
}

export function trackBingUpgrade() {
  // window.uetq && window.uetq.push('event', 'page_view', { page_path: '/success-upgrade' });
}

export function getRomanceGuardParam() {
  return cookies.get('__RG');
}

export function getSessionTokenFromCookie() {
  return cookies.get('session_token');
}

export function getConsentCookie() {
  const value = cookies.get(config.COOKIE_CONSENT_NAME);
  if (typeof value === 'string') {
    // return boolean value
    return value === 'true';
  }
  return undefined;
}

export function trackNewProfile() {
  window.snaptr && window.snaptr('track', 'SIGN_UP');
  // Google Tag Lead conversion tracking
  if (window.gtag) {
    const googleTagObj = { send_to: window.gTagSendToLead };
    if (config.TYPE !== 'adult') {
      googleTagObj.value = 2.0;
      googleTagObj.currency = 'USD';
    }
    window.gtag('event', 'conversion', googleTagObj);

    if (window.gTagSendForSignup) {
      window.gtag('event', 'conversion', { send_to: window.gTagSendForSignup });
    }
  }

  trackBingCreateAccount();
  config.FB_TRACKING_PIXEL_ID &&
    config.FB_TRACKING_PIXEL_ID !== '' &&
    ReactPixel.track('Lead');
  config.TIKTOK_PIXEL &&
    window.ttq &&
    TiktokPixel.track('CompleteRegistration');

  // Verizon Media Tag
  if (config.VERIZON_TRACKING_PIXEL && window.dotq) {
    window.dotq.push({
      projectId: '10000',
      properties: {
        pixelId: config.VERIZON_TRACKING_PIXEL,
        qstrings: {
          et: 'custom',
          ec: 'lead',
        },
      },
    });
  }

  if (window._tfa) {
    // Taboola Pixel Code
    window._tfa.push({
      notify: 'event',
      name: config.TITLE.replace(/\s/g, '') + '-Lead',
      id: config.TABOOLA_TRACKING_PIXEL,
    });

    window._tfa.push({
      notify: 'event',
      name: 'user_signup',
      id: config.TABOOLA_TRACKING_PIXEL,
    });
  }
}

export function trackNewPurchase(siteValue = 0) {
  window.snaptr && window.snaptr('track', 'PURCHASE');
  trackBingUpgrade();
  config.FB_TRACKING_PIXEL_ID &&
    ReactPixel.track('Purchase', { currency: 'USD', value: +siteValue });
  config.TIKTOK_PIXEL &&
    window.ttq &&
    TiktokPixel.track('Subscribe', { currency: 'USD', value: +siteValue });

  // Verizon Media Tag
  if (config.VERIZON_TRACKING_PIXEL && window.dotq) {
    window.dotq.push({
      projectId: '10000',
      properties: {
        pixelId: config.VERIZON_TRACKING_PIXEL,
        qstrings: {
          et: 'custom',
          ec: 'purchase',
          gv: '10.00',
        },
      },
    });
  }

  if (window._tfa) {
    // Taboola Pixel Code
    window._tfa.push({
      notify: 'event',
      name: config.TITLE.replace(/\s/g, '') + '-Purchase',
      id: 1730669,
      revenue: '10',
    });
  }
}

export function getTwoLetterCountryCode(code, fallback = 'en') {
  return code.length === 2 ? code : countryCode[code] || fallback;
}

export function getCleanUsername(string) {
  let cleanUsername = string.replaceAll(/[^a-z0-9]/gi, '');
  while (cleanUsername.length < 8) {
    cleanUsername += Math.floor(Math.random() * 5);
  }
  // make uppercase
  return cleanUsername.replace(/\w/, (c) => c.toUpperCase());
}

export function validateUsername(username) {
  if (typeof username !== 'string') {
    return false;
  }

  const regExp = /^[A-Za-z0-9]{6,14}$/g;
  return regExp.test(username);
}

export function checkUsernameForNumbersOnly(username) {
  const numReg = /[0-9]/g;
  const letReg = /[A-Za-z]/g;

  return numReg.test(username) && !letReg.test(username);
}

export function checkForCharactersInNumbers(value) {
  const regExp = /(?!^\d+$)^.+$/gi;
  return regExp.test(value);
}

export function fakeApi(fakeResponse = {}, isSuccess = true, timeout = 3000) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (isSuccess) {
        resolve(fakeResponse);
      } else {
        reject(fakeResponse);
      }
    }, timeout);
  });
}

export function checkDateInPast(year, month) {
  const today = new Date();
  const dateToCheck = new Date();
  dateToCheck.setFullYear(year, month - 1, 1);

  return dateToCheck < today;
}

export function getGenderSeekingComboByWeight(stats = []) {
  if (isEmpty(stats)) {
    return false;
  }

  if (stats.length === 1) {
    return stats[0];
  }

  const filteredStats = stats.filter((s) => s.seeking.length === 1);

  const sortedStats = filteredStats.sort((a, b) =>
    a.freqency_weight > b.freqency_weight ? -1 : 1
  );

  return sortedStats[0];
}

export function findIndexForModal(modals, action) {
  let idx = modals.findIndex((m) => m.action === action);
  return idx + 1;
}

export function isMobileSafari() {
  return (
    navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
    navigator.userAgent.match(/AppleWebKit/)
  );
}



// WEBPACK FOOTER //
// ./src/assets/helpers/utils.js